import {AppStore, useDateValue} from "../useAppPullState";
import {useDays} from "./useDays";
import {useFilteredCourses} from "./useGolfCourses";

export function useCoursesList() {
    const [dateValue, setDateValue] = useDateValue()
    const days = useDays(dateValue);
    const bookings = AppStore.useState(s => s.bookings)

    // group by date
    const bookedSlots = bookings?.reduce((acc, cur) => {
        const date = cur?.data?.date;
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(cur);
        return acc;
    }, {}) || {};

    const {filteredGolfCourses} = useFilteredCourses();
    return {dateValue, setDateValue, days, bookedSlots, filteredGolfCourses};
}
